import React, { useEffect, useRef, useState } from "react";
import Table from "../../components/common/table/Table";
import ExcelExport from "../../components/common/ui/Export/ExcelExport";
import Button from "../../components/common/ui/Button";
import {
  DateInput,
  SelectInput,
  TextInput,
} from "../../components/common/ui/Inputs";
import { useDispatch, useSelector } from "react-redux";
import {
  authActions,
  inmateAction,
  masterActions,
  messagesAction,
  publicUserActions,
} from "../../_store";
import {
  fDate,
  getCurrentDate,
  getPastDate,
  MinDate,
  Today,
  formatDateTimeAMPM,
} from "../../utils/formatTime";
import CustomLoader from "../../components/common/ui/Loader";
import { history } from "../../_helpers";

import ReadDelete from "../../assets/svg/read-and-delete.svg";

import UnReadMsgDelete from "../../assets/svg/unread-message-delete.svg";

import MessageQuaratine from "../../assets/svg/Quarantine_msg.svg";

import ReadMessage from "../../assets/svg/Read-Message.svg";

import UnReadmail from "../../assets/svg/unread-icon-new.svg";

import RejectQuarantine from "../../assets/svg/Quarantine_rejected_msg.svg";

import CODPending from "../../assets/svg/cod_pending.svg";
import generateXlsx from "../../components/common/export/generateXlsx";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";
import Swal from "sweetalert2";
import useManagementUserAccessPermission from "../../hooks/useManagementUserAccessPermission";
import generateMessageXlsx from "../../components/common/export/generateMessageXlsx";
import { useNavigate } from "react-router-dom";
import { handleDateRangeBlur } from "../../hooks/useDateRangeBlur";
import { handleDateInput } from "../../hooks/useDateInputHandler";
import { transformMessages } from "../../_helpers/transformMessages";

function MessageList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isSignalRData = useSelector((state) => state?.auth?.isSignalRData);

  const facilityCode = useSelector((x) => x?.auth?.commonFacilityCode);

  const { direction, flag, podStatusOptions, MessageStatus } = useSelector(
    (x) => x?.dropdownOptions
  );

  const [isloading, setisloading] = useState(false);
  const { messagesList, loading, messageSearchData, messageSearch } = useSelector(
    (x) => x?.messages
  );
  const startDate = new Date(2017, 0, 1);
  let sorting = false;

  const { isPageReload: isPageReloading, isDashboardPage, isBacktoDashboard, ismsgFlagDisabled } = useSelector((state) => state.master);

  const user = useSelector((x) => x.auth.user);

  const [linkshow, setLinkshow] = useState(false);

  const [errorMessage, setErrorMessage] = useState({
    startDate: "",
    endDate: ""
  });

  const [showSearchFields, setShowSearchFields] = useState(false);
  const { InmateAccessPermission, MessageAccessPermission, PuAccessPermission } = useManagementUserAccessPermission();

  const getCurrentDateTime = () => {
    const now = new Date();
    const newTime = new Date(now.getTime() + 230000);
    const dtf = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    });

    const parts = dtf.formatToParts(newTime).reduce((acc, p) => {
      acc[p.type] = p.value;
      return acc;
    }, {});

    const month = parts.month;
    const day = parts.day;
    const year = parts.year;
    const hour = parts.hour.padStart(2, '0');
    const minute = parts.minute;
    const second = parts.second;
    const ampm = parts.dayPeriod || (Number(hour) >= 12 ? 'PM' : 'AM');

    return `${month}/${day}/${year} ${hour}:${minute}:${second} ${ampm}`;
  };


  useEffect(() => {
    if (facilityCode === 0) return;
    const searchData = { ...messageSearchData };
    searchData.FacilityID = facilityCode;
    if (isDashboardPage) {
      searchData.MessageSendStartDate = "01/01/2017";
      searchData.MessageFlag = 2;
      searchData.MessageStatus = "5";
      searchData.SortBy = "MessageStatus asc";
      searchData.PageNo = 1;
      searchData.RowCountPerPage = 10;
      dispatch(messagesAction?.setMessageSearchData(searchData));
    }
    setisloading(true);
    dispatch(messagesAction?.getMessagesList(searchData)).then((x) => { setisloading(false) });
  }, [facilityCode, isPageReloading, isDashboardPage]);

  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({
        facilityID: 0,
        activeStatus: 1,
      })
    );
  }, []);


  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
      .format(date)
      .replace(",", "");
  };

  const findGraphemeClusters = (input, returninput) => {
    const segmenter = new Intl.Segmenter("en", { granularity: "grapheme" });
    if (returninput)
      return (
        Array.from(segmenter.segment(input))
          .slice(0, 15)
          .map((item) => item.segment)
          .join("") + "..."
      );
    else return Array.from(segmenter.segment(input));
  };

  const columns = [
    {
      key: "MessageSubject",
      name: "Subject",
      selector: (row) => row?.MessageID,
      cell: (row, index) => (
        <div
          onClick={() => pageNavigate(row.MessageID, index)}
          className={` ${MessageAccessPermission[0]?.SubMenuActiveStatus !== 0
            ? "Common_Link_Style"
            : ""
            }`}
        >
          {findGraphemeClusters(row.FullMessageSubject, false)?.length > 15
            ? findGraphemeClusters(row.FullMessageSubject, true)
            : row.FullMessageSubject}
        </div>
      ),
      sortable: true,
    },
    {
      width: "130px",
      key: "MessageFrom",

      name: "From",
      selector: (row) => row?.MessageFrom,
      cell: (row) => (
        <div className="d-flex gap-1 align-items-center">
          <div
            className={
              row?.Sender === "PublicUser"
                ? "user-batch button-success"
                : "user-batch button-primary"
            }
          ></div>
          <div
            className={` ${row?.Sender === "PublicUser" ? PuAccessPermission[0]?.SubMenuActiveStatus !== 0 ? "Common_Link_Style" : "" :
              (InmateAccessPermission[0]?.SubMenuActiveStatus !== 0 && user?.UserRoleID !== 13) ? "Common_Link_Style" : ""
              }`}
            //onClick={() => handleNavigatePublicInfo(row)}
            onClick={() => {
              if (row?.Sender === "PublicUser") {
                handleNavigatePublicInfo(row);
                return;
              } else {
                handleNavigateInmateInfo(row);
              }
            }}
          >
            {row?.MessageFrom}
          </div>
        </div>
      ),
      sortable: true,
    },
    {
      width: "130px",
      key: "MessageTo",
      name: "To",
      selector: (row) => row?.MessageTo,
      sortable: true,
      cell: (row) => (
        <div className="d-flex  gap-1 align-items-center">
          <div
            className={
              row?.Sender === "Inmate"
                ? "user-batch button-success"
                : "user-batch button-primary"
            }
          ></div>
          <div
            className={` ${row?.Receiver === "Inmate" ? (InmateAccessPermission[0]?.SubMenuActiveStatus !== 0 && user?.UserRoleID !== 13) ? "Common_Link_Style" : "" :
              PuAccessPermission[0]?.SubMenuActiveStatus !== 0 ? "Common_Link_Style" : ""
              }`}
            onClick={() => {
              if (row?.Receiver === "Inmate") {
                handleNavigateInmateInfo(row);
                return;
              } else {
                handleNavigatePublicInfo(row);
              }
            }}
          >
            {row?.MessageTo}
          </div>
        </div>
      ),
    },
    {
      width: "100px",
      key: "InmateResidentId",
      name: "Inmate ID",
      selector: (row) => row?.InmateResidentId,
      cell: (row) => (
        <div className="d-flex flex-wrap gap-1 align-items-center">
          {/* <div className="user-batch button-primary"></div> */}
          <div
            className={` ${(InmateAccessPermission[0]?.SubMenuActiveStatus !== 0 && user?.UserRoleID !== 13) ? "Common_Link_Style" : ""
              }`}
            onClick={() => handleNavigateInmateInfoID(row)}
          >
            {row?.InmateResidentId}
          </div>
        </div>
      ),
      sortable: true,
    },
    {
      width: "90px",
      key: "MessageCost",
      name: "Cost($)",
      selector: (row) => row?.MessageCost?.toFixed(2),
      sortable: true,
    },
    {
      key: "ModeOfPayment",
      name: "Mode of Payment",
      selector: (row) => row?.ModeOfPayment,
      sortable: true,
    },

    {
      width: "60px",
      key: "MessageFlag",
      name: "Flag",
      selector: (row) => row.MessageFlag,
      sortable: true,
      cell: (row) =>
        row?.MessageFlag === 2 || row?.MessageFlag === 1 ? (
          <i
            className="fa fa-flag flagged-message fs-5"
            aria-hidden="true"
            title={
              row?.MessageBothFlagKeyWords?.trim()?.length > 0
                ? row?.MessageBothFlagKeyWords
                : ""
            }
          ></i>
        ) : (
          <i
            className="fa fa-flag non-flagged-message fs-5"
            aria-hidden="true"
            title={
              row?.MessageBothFlagKeyWords?.trim()?.length > 0
                ? row?.MessageBothFlagKeyWords
                : ""
            }
          ></i>
        ),
    },
    {
      key: "MessageSentDate",
      name: "Sent",
      selector: (row) => {
        const date = new Date(row.MessageSentDate);

        // Create an Intl.DateTimeFormat object for custom formatting
        const options = {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true, // 12-hour format (AM/PM)
        };

        // Format the date using the options
        const formattedDate = new Intl.DateTimeFormat("en-US", options).format(
          date
        );

        // Replace the comma with an empty string to remove it
        return formattedDate.replace(",", ""); // "11/07/2024 01:41 AM"
      },
      cell: (row) => (
        <div className="d-flex flex-wrap ">
          <div className="font-size-13 fw-500 ">
            {formatDate(row?.MessageSentDate)}
          </div>
        </div>
      ),
      sortable: true,
    },
    {
      key: "MessageReceiveDate",
      name: "Read",
      selector: (row) => {
        if (!row?.MessageReceiveDate || row?.MessageReceiveDate == "0001-01-01T00:00:00" || row?.MessageStatus !== "Read") return "-"; // Return an empty string if no date is provided

        const date = new Date(row.MessageReceiveDate);


        const options = {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true, // 12-hour format (AM/PM)
        };

        // Format the date using the options
        const formattedDate = new Intl.DateTimeFormat("en-US", options).format(
          date
        );

        // Replace the comma with an empty string to remove it
        return formattedDate.replace(",", ""); // "11/07/2024 01:41 AM"
      },
      cell: (row) => (
        <div className="d-flex flex-wrap ">
          <div className="font-size-13 fw-500 ">
            {(row?.MessageReceiveDate == "0001-01-01T00:00:00" || row?.ModeOfPayment == "COD") ? "-" : formatDate(row?.MessageReceiveDate)}
          </div>
        </div>
      ),

      sortable: true,
    },
    {
      key: "MessageStatus",
      width: "80px",
      name: "Status",
      selector: (row) => row?.MessageStatus,
      cell: (row) =>
        row?.MessageStatus === "Read" && row?.IsReceiverMsgDelete === 1 ? (
          <div title="Read & Message Deleted">
            <img alt="status" src={ReadDelete} className="msg-icon" />
          </div>
        ) : row?.MessageStatus === "Unread" &&
          row?.IsReceiverMsgDelete === 1 ? (
          <div title="Unread & Message Deleted">
            <img alt="status" src={UnReadMsgDelete} className="msg-icon" />
          </div>
        ) : row?.MessageStatus === "Read" ? (
          <div title="Read">
            <img alt="status" src={ReadMessage} className="msg-icon" />
          </div>
        ) : row?.MessageStatus === "Unread" ? (
          <div title="Unread">
            <img
              alt="status"
              src={UnReadmail}
              style={{ height: "26px", width: "26px" }}
              title="Unread"
            />
          </div>
        ) : row?.MessageStatus === "Pending Quarantine Approval" ? (
          <div title="Quarantine Message">
            <img alt="status" src={MessageQuaratine} className="msg-icon" />
          </div>
        ) : row?.MessageStatus === "Reject Quarantine" ? (
          <div title="Quarantine Rejected">
            <img alt="status" src={RejectQuarantine} className="msg-icon" />
          </div>
        ) : (
          <div title="C.O.D Pending">
            <img alt="status" src={CODPending} className="msg-icon" />
          </div>
        ),
      sortable: true,
    },

    ...(messagesList?.DataList?.[0]?.FacilityReview === 1
      ? [
        {
          width: "100px",
          key: "MessageReviewCommand",
          name: "Review Status",
          selector: (row) => row.FacilityReview,
          cell: (row) =>
            row.FacilityReview === 1 &&
              row?.MessageReviewCommand === "" &&
              row?.MessageReviewCommandBy === "" &&
              row?.FacilityReviewStatus === "1" ? (
              <span className="status-Closed">Pending </span>
            ) : (row.FacilityReview === 1 &&
              (row?.MessageReviewCommand !== "" || row?.MessageReviewCommandBy !== "") &&
              row?.FacilityReviewStatus === "1") ? (
              <span className="status-open">Reviewed</span>
            ) : row?.FacilityReview === 1 &&
              row?.FacilityReviewStatus === "0" ? (
              "-"
            ) : (
              ""
            ),
          sortable: true,
        },
      ]
      : []),

  ];

  const handleNavigatePublicInfo = (row) => {
    if (PuAccessPermission[0]?.SubMenuActiveStatus == 0) return;
    dispatch(publicUserActions?.setPublicUserTab("publicuser-info-tab"));
    history.navigate("PublicUserList/Details", {
      state: { row: row, source: "message" },
    });
  };
  const handleNavigateInmateInfo = (row) => {
    if (InmateAccessPermission[0]?.SubMenuActiveStatus == 0 || user?.UserRoleID == 13) return;
    dispatch(inmateAction.setInmateCurrentTab("inmate-info-tab"));

    history.navigate("InmateList/Details", {
      state: { inmate: row, source: "message", showTransactionTab: true },
    });
  };
  const handleNavigateInmateInfoID = (row) => {
    if (InmateAccessPermission[0]?.SubMenuActiveStatus == 0 || user?.UserRoleID == 13) return;
    dispatch(inmateAction?.setInmateCurrentTab("inmate-info-tab"));
    history.navigate("InmateList/Details", {
      state: { inmate: row, source: "message", showTransactionTab: true },
    });
  };

  const paginationTriggered = useRef(false);


  const minDate = new Date(2017, 0, 1); // January 1, 2017
  const today = new Date();

  const handleChange = (e, type) => {
    paginationTriggered.current = true;
    const searchData = { ...messageSearchData };
    // searchData.PageNo = 1; // Always reset to first page
    // searchData.RowCountPerPage = 10;
    searchData.FacilityID = facilityCode;
    if (
      type === "InmateStatus" ||
      type === "MessageDirection" ||
      type === "MessageFlag" ||
      type === "MessageStatus"
    ) {
      //select boxes
      const value = e?.value;
      searchData[type] =
        value !== undefined
          ? value
          : type === "InmateStatus"
            ? 1
            : type === "MessageDirection"
              ? 0
              : type === "MessageStatus"
                ? 0
                : 3;
      searchData.PageNo = 1;
      searchData.RowCountPerPage = 10;
      const isValid = handleCheckSearchDate();
      if (!isValid) return;
      dispatch(messagesAction.getMessagesList(searchData));
    } else if (
      type === "MessageSendStartDate" ||
      type === "MessageSendEndDate"
    ) {
      //date pickers
      // const date = e?.getDate();
      // const month = e?.getMonth() + 1;
      // const year = e?.getFullYear();
      // const dateValue = month + "/" + date + "/" + year;
      const date = fDate(e);

      // Validate date range for manual typing
      const inputDate = new Date(date);


      if (inputDate >= minDate && inputDate <= today) {
        searchData[type] = date;
      } else {
        // If invalid date, don't update and keep previous value
        return;
      }
    } else {
      //text and number fields
      const { value } = e?.target;
      if (type === "InmateResidentId") {
        const regex = /^[0-9\s]*$/;
        if (!regex.test(value)) return;
      }
      searchData[type] = type === "InmateID" ? parseInt(value) : value;
    }
    // setMessagesSearch(messageSearchData);

    dispatch(messagesAction?.setMessageSearchData(searchData));
  };


  const handleDateEnterKey = (event, name) => {
    handleDateInput({
      event,
      name,
      minDate: new Date(2017, 0, 1),
      maxDate: new Date(),
      onBlur: handleDateBlur,
    });
  };

  const handleDateBlur = (e, fieldName, manualValue) => {
    const value = manualValue || e.target.value;

    const updatedParam = handleDateRangeBlur({
      value,
      fieldName,
      startKey: "MessageSendStartDate",
      endKey: "MessageSendEndDate",
      searchdata: messageSearchData,
      setErrorMessage
    });

    dispatch(messagesAction.setMessageSearchData(updatedParam));
  };

  const pageNavigate = (messageID, index) => {
    if (linkshow === true) return;
    dispatch(masterActions.UpdateisDashboardPage(false));
    Swal.close();

    if (MessageAccessPermission[0]?.SubMenuActiveStatus === 0) {
      // showToastNotification(
      //   "View option has been disabled by the admin.",
      //   "error"
      // );
      setLinkshow(true);
      return;
    }
    setisloading(true);
    const searchData = { ...messageSearchData };
    searchData.RowCountPerPage = messagesList?.TotalRecordCount || 1000;
    searchData.PageNo = 1;
    searchData.FacilityID = facilityCode;
    // dispatch(messagesAction?.GetLoadMessageIDList(searchData)).then(x => {
    let result = messagesList;
    let findIndex = result?.DataList?.findIndex(x => x?.MessageID === messageID);
    setisloading(false);
    history.navigate("MessageList/Conversation", {
      state: { messageID: messageID, index: findIndex ? findIndex : index, source: "messageList" },
    });
    //var messageId = findIndex > 0 ? result?.DataList?.[findIndex]?.MessageID : messageID;
    // const params = {
    //   messageID: messageId,
    //   sortBy: "MessageID Desc",
    //   pageNo: 1,
    //   rowCountPerPage: 1000,
    // };
    // dispatch(messagesAction?.getMessageConversationDetails(params))
    //   .then((result) => {
    //     setisloading(false);
    //     history.navigate("MessageList/Conversation", {
    //       state: { messageID: messageID, index: findIndex ? findIndex : index, source: "messageList", messageDetails: result?.payload?.DataList },
    //     });
    //   });
    // });


  };

  const handleRowPerPage = (page) => {
    const searchData = { ...messageSearchData };
    searchData.RowCountPerPage = page;
    searchData.PageNo = 1;
    searchData.FacilityID = facilityCode;
    dispatch(messagesAction?.getMessagesList(searchData));
    dispatch(messagesAction?.setMessageSearchData(searchData));
    // setMessagesSearch((prevState) => ({
    //   ...prevState,
    //   RowCountPerPage: page,
    // }));
  };

  const handlePageChange = (page, { manual = false } = {}) => {
    // if (!manual) return; // ignore automatic calls
    if (paginationTriggered.current) {
      paginationTriggered.current = false;
      return;
    }

    if (sorting) {
      sorting = false;
      return;
    }
    const searchData = { ...messageSearchData };
    searchData.PageNo = page;
    searchData.FacilityID = facilityCode;
    dispatch(messagesAction?.getMessagesList(searchData));
    dispatch(messagesAction?.setMessageSearchData(searchData));
    // setMessagesSearch((prevState) => ({
    //   ...prevState,
    //   PageNo: page,
    // }));
  };

  const exportDocAsExcel = () => {
    setisloading(true);
    let generateExcelColumns = [
      "Subject",
      "From",
      "To",
      "Inmate ID",
      "Message Cost($)",
      "Flag",
      "Sent",
      "Read",
      "Status",
      "Is COD Message",
      "Mode of Payment",
      "COD Status",
      "Approved/Reject by",
      "User Type",
    ];

    const updateTotalRows = {
      ...messageSearchData,
      rowCountPerPage: messagesList?.TotalRecordCount,
      FacilityID: facilityCode,
      exportExcel: true,
      pageNo: 1,
    };

    dispatch(messagesAction?.getExportMessagesList(updateTotalRows))
      .then((result) => {
        const data = result?.payload || [];
        // const result1 = transformMessages(data);
        const dataList = data?.DataList;
        let exportData =
          result &&
          dataList?.map((obj) => ({
            // "Form Title": obj?.FullMessageSubject,
            Subject: obj?.FullMessageSubject,
            From: obj?.MessageFrom,
            To: obj?.MessageTo,
            "Inmate ID": obj?.InmateResidentId,
            "Message Cost($)": obj?.MessageCost?.toFixed(2),
            Flag: obj?.MessageBothFlagKeyWords,
            Sent: obj?.MessageSentDate ? formatDateTimeAMPM(obj.MessageSentDate) : "-",
            // Read: obj?.MessageReceiveDate ? formatDateTimeAMPM(obj.MessageReceiveDate) : "-",
            Read: (obj?.MessageReceiveDate == "0001-01-01T00:00:00" || obj?.ModeOfPayment == "COD") ? "-" : formatDateTimeAMPM(obj.MessageReceiveDate),
            Status:
              (obj?.MessageStatus === "Read" && obj?.IsReceiverMsgDelete == 1) ? "Read & Message Deleted" :
                (obj?.MessageStatus === "Unread" && obj?.IsReceiverMsgDelete === 1) ? "Unread & Message Deleted" :
                  obj?.MessageStatus === "Read" ? "Read" :
                    obj?.MessageStatus === "Unread" ? "Unread" :
                      obj?.MessageStatus === "Pending Quarantine Approval" ? "Quarantine Message" :
                        obj?.MessageStatus === "Reject Quarantine" ? "Quarantine Rejected" :
                          "C.O.D Pending",
            "Is COD Message": obj?.IsCODMessage,
            // "Is COD Message": obj?.IsCODMessage,
            "Mode of Payment": obj?.ModeOfPayment,
            "COD Status": obj?.CODStatus,
            "Approved/Reject by": obj?.ApproveOrRejectedBy,
            "User Type": obj?.UserType,
          }));
        generateMessageXlsx(exportData, generateExcelColumns, "Message List");
        setisloading(false);
      })
      .catch((err) => {
        setisloading(false);
        showToastNotification("Error in Export Data", "error");
      });
  };

  const handleCheckSearchDate = () => {
    const { MessageSendStartDate, MessageSendEndDate } = messageSearchData;
    if (!MessageSendStartDate || !MessageSendEndDate) {
      setErrorMessage({
        MessageSendStartDate: !MessageSendStartDate ? "Please select From Date." : "",
        MessageSendEndDate: !MessageSendEndDate ? "Please select End Date." : "",
      });
      return false;
    }
    return true
  }

  const handleFormSubmit = (e) => {
    e?.preventDefault();

    const isValid = handleCheckSearchDate();
    if (!isValid) return;

    const searchData = { ...messageSearchData, PageNo: 1, RowCountPerPage: 10 };
    searchData["FacilityID"] = facilityCode;
    dispatch(messagesAction?.setMessageSearchData(searchData));
    setisloading(true);
    dispatch(messagesAction.getMessagesList(searchData)).then((x) => { setisloading(false) })
  };

  const handleSearchReset = () => {
    setErrorMessage(false);
    dispatch(masterActions.updateismsgFlagDisabled(false));
    paginationTriggered.current = false;
    sorting = false;
    const resetSearch = {
      FacilityID: facilityCode,
      InmateResidentId: "",
      ManagementUserID: 1,
      PublicUserID: 0,
      PublicFirstName: "",
      PublicLastName: "",
      InmateFirstName: "",
      InmateLastName: "",
      MessageSubject: "",
      InmateStatus: 1,
      MessageDirection: 0,
      MessageSendStartDate: getPastDate(1),
      MessageSendEndDate: getCurrentDate(1),
      MessageFlag: 3,
      MessageStatus: "0",
      PageNo: 1,
      RowCountPerPage: 10,
      SortBy: "MessageID DESC",
    };
    dispatch(messagesAction?.setMessageSearchData(resetSearch));
    // setMessagesSearch(resetSearch);
    dispatch(messagesAction?.getMessagesList(resetSearch));
  };

  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    sorting = true;
    const search = { ...messageSearchData, FacilityID: facilityCode };
    const newSortOrder = search.SortBy?.includes(column.key)
      ? search.SortBy.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";
    search.SortBy = `${column.key} ${newSortOrder}`;
    dispatch(messagesAction?.setMessageSearchData(search));
    dispatch(
      messagesAction.getMessagesList({
        ...messageSearchData,
        FacilityID: facilityCode,
        SortBy: `${column.key} ${newSortOrder}`,
      })
    );
  };

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };

  const handleBack = () => {
    navigate("/Admin/Dashboard");
  }

  const renderSearch = () => {
    return (
      <form onSubmit={(e) => handleFormSubmit(e)}>
        <div className="row">
          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <TextInput
                name="InmateResidentId"
                id="code"
                label="Inmate ID"
                value={messageSearchData?.InmateResidentId}
                handleChange={(e) => handleChange(e, "InmateResidentId")}
                placeholder="Enter Inmate ID"
                maxLength={20}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <TextInput
                name="InmateLastName"
                id="name"
                label="Inmate Last Name"
                value={messageSearchData?.InmateLastName}
                handleChange={(e) => handleChange(e, "InmateLastName")}
                placeholder="Enter Last Name"
                required={false}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <TextInput
                name="inmateFirstName"
                id="inmateFirstName"
                label="Inmate First Name"
                value={messageSearchData?.InmateFirstName}
                handleChange={(e) => handleChange(e, "InmateFirstName")}
                placeholder="Enter First Name"
                required={false}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <SelectInput
                options={podStatusOptions}
                name="InmateStatus"
                id="InmateStatus"
                label="Inmate Status"
                value={messageSearchData?.InmateStatus}
                handleChange={(e) => handleChange(e, "InmateStatus")}
                isClearable={messageSearchData?.InmateStatus !== 1}
                placeholder="Select"
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <TextInput
                name="PublicFirstName"
                id="PublicFirstName"
                label="Public User First Name"
                value={messageSearchData?.PublicFirstName}
                handleChange={(e) => handleChange(e, "PublicFirstName")}
                placeholder="Enter First Name"
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <TextInput
                name="PublicLastName"
                id="PublicLastName"
                label="Public User Last Name"
                value={messageSearchData?.PublicLastName}
                handleChange={(e) => handleChange(e, "PublicLastName")}
                placeholder="Enter Last Name"
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <DateInput
                label="From Date"
                name="MessageSendStartDate"
                value={messageSearchData?.MessageSendStartDate}
                handleChange={(e) => handleChange(e, "MessageSendStartDate")}
                placeholderText="Select a date"
                yearDropDown
                isClearable={false}
                // preventClear
                minDate={new Date(2017, 0, 1)}
                maxDate={
                  messageSearchData?.MessageSendEndDate
                    ? messageSearchData?.MessageSendEndDate
                    : new Date()
                }
                required={true}
                handleBlur={(e) => handleDateBlur(e, "MessageSendStartDate")}
                handleKeyDown={(e) =>
                  handleDateEnterKey(e, "MessageSendStartDate")
                }
                errorMessage={messageSearchData?.MessageSendStartDate ? {} : errorMessage}
              />
              {/* {errorMessage.startDate && (
                <div className="text-danger small mt-1">{errorMessage.startDate}</div>
              )} */}
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <DateInput
                label="End Date"
                name="MessageSendEndDate"
                value={messageSearchData?.MessageSendEndDate}
                isClearable={false}
                placeholderText="Select a date"
                handleChange={(e) => handleChange(e, "MessageSendEndDate")}
                // minDate={
                //   messageSearchData?.MessageSendStartDate
                //     ? messageSearchData?.MessageSendStartDate
                //     : new Date(2017, 0, 1)
                // }
                // maxDate={new Date()}
                maxDate={
                  messageSearchData?.MessageSendStartDate !== ""
                    ? new Date(
                      Math.min(
                        new Date(messageSearchData?.MessageSendStartDate).setFullYear(
                          new Date(messageSearchData?.MessageSendStartDate).getFullYear() + 1
                        ), // 1 year after fromDate
                        new Date() // Current date
                      )
                    )
                    : new Date()
                }
                required={true}
                minDate={messageSearchData?.MessageSendStartDate ? messageSearchData?.MessageSendStartDate : startDate}
                handleBlur={(e) => handleDateBlur(e, "MessageSendEndDate")}
                handleKeyDown={(e) =>
                  handleDateEnterKey(e, "MessageSendEndDate")
                }
                // preventClear
                errorMessage={messageSearchData?.MessageSendEndDate ? {} : errorMessage}
              />
              {/* {errorMessage.endDate && (
                <div className="text-danger small mt-1">{errorMessage.endDate}</div>
              )} */}
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <SelectInput
                options={direction}
                name="messageDirection"
                id="messageDirection"
                label="Direction"
                value={messageSearchData?.MessageDirection}
                handleChange={(e) => handleChange(e, "MessageDirection")}
                placeholder="Select"
                isClearable={messageSearchData?.MessageDirection}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <SelectInput
                options={flag}
                name="MessageFlag"
                id="MessageFlag"
                label="Flag"
                value={messageSearchData?.MessageFlag}
                handleChange={(e) => handleChange(e, "MessageFlag")}
                placeholder="Select"
                isClearable={messageSearchData?.MessageFlag !== 3}
                isDisabled={ismsgFlagDisabled}
              />
            </div>
          </div>

          {/* <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <SelectInput
                options={MessageStatus}
                name="MessageStatus"
                id="MessageStatus"
                label="Message Status"
                value={messageSearchData?.MessageStatus}
                handleChange={(e) => handleChange(e, "MessageStatus")}
                placeholder="-- ALL --"
                isClearable={messageSearchData?.MessageStatus != 0}
                isDisabled={ismsgFlagDisabled}
              />
            </div>
          </div> */}

          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              {/* Status */}
              <TextInput
                name="MessageSubject"
                id="MessageSubject"
                label="Subject"
                value={messageSearchData?.MessageSubject}
                handleChange={(e) => handleChange(e, "MessageSubject")}
                placeholder="Enter subject"
              />
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="d-flex flex-wrap justify-content-center gap-3 flex-wrap mt-3">
          <Button
            variant="primary"
            className="me-2"
            label={"SEARCH"}
            type={"submit"}
            status={"primary"}
            disabled={false}
            icon={"search"}
          />

          <Button
            variant="secondary"
            className="me-2"
            onClick={handleSearchReset}
            label="RESET"
            type="button"
            icon={"fa-solid fa-rotate-right"}
            status="secondary"
            disabled={false}
          />
        </div>
      </form>
    );
  };

  if (loading || isloading) return <CustomLoader />;

  return (
    <>
      {facilityCode > 0 ? (
        <div className="messages">
          <div className="d-flex flex-wrap flex-column justify-content-center align-items-center position-relative">
            <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100">

              {/* Mobile Only */}
              {isBacktoDashboard && (
                <div className="d-block d-md-none card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100">
                  <div className="d-flex justify-content-end">
                    <Button
                      label="BACK To DashBoard"
                      type="button"
                      className="me-2"
                      onClick={() => handleBack()}
                      variant="danger"
                      status={"primary"}
                      icon={"fa-solid fa-angle-left"}
                      disabled={false}
                    />
                  </div>
                </div>
              )}


              {/* Mobile only (Below md breakpoint) */}
              <div className=" d-block d-md-none">
                <div
                  className=" d-flex align-items-center justify-content-between"
                  style={{ background: "transparent", cursor: "pointer" }}
                  onClick={toggleInformation}
                >
                  <h2 className="form_title_uppercase text-color">
                    MESSAGE SEARCH
                  </h2>
                  <i
                    id="itagInformation"
                    className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""
                      }`}
                    style={{ fontSize: "20px" }}
                  ></i>
                </div>
              </div>

              {/* Mobile only (Below md breakpoint) */}
              <div className="d-block d-md-none mt-2">
                {showSearchFields && renderSearch()}
              </div>
              {/* Web only (Desktop and above) */}
              <div className="mb-3 d-none d-md-block">
                <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap resp-space ">
                  <h2 className="form_title_uppercase text-color">
                    MESSAGE SEARCH
                  </h2>
                  {isBacktoDashboard && (
                    <div className="d-flex flex-wrap gap-3">
                      <Button
                        label="BACK To DashBoard"
                        type="button"
                        className=" me-2"
                        onClick={() => handleBack()}
                        variant="danger"
                        status={"primary"}
                        icon={"fa-solid fa-angle-left"}
                        disabled={false}
                      />
                    </div>
                  )}
                </div>
              </div>
              {/* Web only (Desktop and above) */}
              <div className="d-none d-md-block">{renderSearch()}</div>

            </div>

            <div className="card shadow-sm b-r-all  p-4 border border-dark-grey mt-3 w-100 mb-4 resp-space">
              <div className="d-flex flex-wrap justify-content-between align-items-center resp-space">
                <h2 className="text-color">MESSAGES LIST</h2>

                {messagesList?.DataList?.length > 0 && (
                  <div className="d-flex flex-wrap gap-3 align-items-center">
                    <ExcelExport handleExcelExport={exportDocAsExcel} />
                  </div>
                )}
              </div>

              {messagesList?.DataList?.length > 0 && (
                <div className="d-flex flex-wrap messageList-gap">
                  <div className="d-flex flex-wrap align-items-center gap-1">
                    <div className="user-batch button-success"></div>
                    <div className="text fs-5">Public Users</div>
                  </div>

                  <div className="d-flex flex-wrap align-items-center gap-1">
                    <div className="user-batch button-primary"></div>
                    <div className="text fs-5">Inmates</div>
                  </div>

                  <div className="d-flex flex-wrap align-items-center gap-1">
                    <i
                      className="fa fa-flag flagged-message"
                      aria-hidden="true"
                    ></i>
                    <div className="text fs-5">Flagged Message</div>
                  </div>

                  <div className="d-flex flex-wrap align-items-center gap-1">
                    <i
                      className="fa fa-flag non-flagged-message"
                      aria-hidden="true"
                    ></i>
                    <div className="text fs-5">Non Flagged Message</div>
                  </div>
                </div>
              )}

              <div className="mt-3">
                <Table
                  columns={columns}
                  data={messagesList?.DataList}
                  pagination
                  onChangeRowsPerPage={handleRowPerPage}
                  onChangePage={handlePageChange}
                  totalRowCount={messagesList?.TotalRecordCount}
                  currentPage={messageSearchData?.PageNo}
                  paginationPerPage={messageSearchData.RowCountPerPage}
                  onSort={handleSort}
                  serverSideSort
                  sortColumn={messageSearchData?.SortBy?.split(" ")[0]}
                  sortDirection={messageSearchData?.SortBy?.split(" ")[1]}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <h4 className="facility-card">Select a Facility Code from the list</h4>
      )}
    </>
  );
}

export default React.memo(MessageList);
